import * as React from "react"

const defaults = {
  controllerUrl: `https://backstage.infict.com`,
  auth0Domain: ``,
  auth0ClientId: ``,
  auth0Audience: undefined,
}

const SiteMetadataContext = React.createContext(defaults)

/**
 * Provides site metadata (controllerUrl, Auth0 config) without useStaticQuery.
 * Avoids "The result of this StaticQuery could not be fetched" when cached
 * JS requests stale query JSON after a deploy. Value comes from:
 * - SSR: gatsby-ssr passes config from gatsby-config
 * - Client: script tag injected by gatsby-ssr (window.__GATSBY_SITE_METADATA__)
 */
export function SiteMetadataProvider({ value, children }) {
  return React.createElement(
    SiteMetadataContext.Provider,
    { value: value || defaults },
    children
  )
}

export function useSiteMetadata() {
  return React.useContext(SiteMetadataContext) || defaults
}

export default SiteMetadataContext
